var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('iframe',{ref:"iframeDom",attrs:{"name":"iframeMap","id":"iframeMapViewComponent","width":"100%","height":"","src":_vm.smgHtmlPath,"frameborder":"0","scrolling":"y"}})])}
var staticRenderFns = []

export { render, staticRenderFns }